export default {
  'article-detail-quotes':
    'quotes-text flex justify-center text-20 font-HelveticaNeueMedium w-85p mdp:w-75p mx-auto leading-28 sm:pl-70 sm:pr-20 lg:px-20 text-center mt-10 mb-24',
  'contentPage-quotes':
    'quotes-text flex justify-center text-20 font-HelveticaNeueMedium w-85p mdp:w-75p mx-auto leading-28 sm:pl-20 sm:pr-20 lg:px-20 text-center mt-10 mb-24',
  'hair-gender-quotes':
    'quotes-text flex justify-center text-20 font-HelveticaNeueMedium w-85p mdp:w-75p mx-auto leading-28 sm:pl-20 sm:pr-20 lg:px-20 text-center mt-35 mb-24',
    'contentPage-quotes-increased-font-size':
    'quotes-text flex justify-center text-40 font-HelveticaNeueMedium w-85p mdp:w-75p mx-auto leading-28 sm:pl-20 sm:pr-20 lg:px-20 text-center mt-10 mb-24',
		};

